import React from 'react';

import CodeInput from './CodeInput';
import LinkExpired from './LinkExpired';
import Success from './Success';

const ModalBody = ({
  registrationUrl,
  resendConfirmationEmailUrl,
  setIsOpen,
  step,
  errorType,
  setStep,
  setErrorType,
  emailToken,
}) => {
  switch (step) {
    case 'CODE_INPUT':
      return <CodeInput
        registrationUrl={registrationUrl}
        resendConfirmationEmailUrl={resendConfirmationEmailUrl}
        setStep={setStep}
        errorType={errorType}
        setErrorType={setErrorType}
      />;
    case 'LINK_EXPIRED':
      return <LinkExpired
        resendConfirmationEmailUrl={resendConfirmationEmailUrl}
        errorType={errorType}
        setIsOpen={setIsOpen}
        setErrorType={setErrorType}
        setStep={setStep}
        emailToken={emailToken}
      />;
    case 'SUCCESS':
    default:
      return <Success />;
  }
};

export default ModalBody;
